module.exports = __webpack_public_path__ + "img/logo-mobile.11acc639.jpg";